import ClimateSVG from "./ClimateChangeSvg.svg";
import Icon from "@ant-design/icons";
const ClimateSvgImg = () => (
   <img src={ClimateSVG} />
);
export default function ClimateChangeIcon() {
  return <Icon
    component={ClimateSvgImg}
  />
}